var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-dropdown-item',{attrs:{"type":"divide"}})
}
var staticRenderFns = []

export { render, staticRenderFns }